module.exports = __webpack_public_path__ + "img/ic_help_circle.4ddb48ce.svg";